
<ul class="nav nav-pills">
    <li class="nav-item p-1">
        <a class="nav-link" (click)="modeAffichage='gout'" [class.active]="modeAffichage=='gout'" >Gout</a>
    </li>
    <li class="nav-item p-1">
        <a class="nav-link" (click)="modeAffichage='temps'" [class.active]="modeAffichage=='temps'" >Temps</a>
    </li>
    <li class="nav-item p-1">
        <a class="nav-link" (click)="modeAffichage='calories'" [class.active]="modeAffichage=='calories'" >Calories</a>
    </li>
</ul>

<p *ngIf="modeAffichage=='gout'" class="card-text p-2">{{gout}}</p>
<p *ngIf="modeAffichage=='temps'" class="card-text p-2">{{tempsDePrep}} minutes</p>
<p *ngIf="modeAffichage=='calories'"class="card-text p-2">{{valeurCalorique}} calories</p>
